import React, { Component } from 'react';
import {
  Button, Card, CardBody, Col, Table, Badge, UncontrolledTooltip, FormGroup,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';

import LocationModal from './LocationModal';
import Location from '../../../services/LocationService';
import global from '../../../global';

class LocationLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      realList: [],
      list: [],
      modal: false,
      formdata: {
        locationName: '',
        address: '',
        type: '',
      },
      title: 'Add',
      errorMsg: '',
    };
    this.isLoading = false;
    this.toggleModal = this.toggleModal.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.addSubmitForm = this.addSubmitForm.bind(this);
    this.editToggle = this.editToggle.bind(this);
    this.editSubmitForm = this.editSubmitForm.bind(this);
    this.updateLocationStatus = this.updateLocationStatus.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadLocations();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  async onLoadLocations() {
    await Location.getLocations()
      .then((response) => {
        const result = response;
        this.setState({ list: result, realList: result });
        this.handleClick();
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formdata: { ...prevState.formdata, [name]: value },
    }));
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ formdata: { locationName: '', address: '', type: '' } });
  };

  updateLocationStatus = (e, id, status) => {
    e.preventDefault();
    const statusTxt = status === 1 ? 'activate' : 'deactivate';

    swal({
      title: 'Confirmation',
      text: `Are you sure you want to ${statusTxt} this location?`,
      icon: 'warning',
      closeOnClickOutside: false,
      buttons: {
        yes: 'YES',
        no: {
          text: 'NOPE',
          dangerMode: true,
        },
      },
    }).then((name) => {
      name = name.toLowerCase();

      if (name === 'yes') {
        Location.updateLocationStatus(id, status).then((result) => {
          if (result) {
            const { list } = this.state;
            list.filter((listResp) => {
              if (listResp.location_id === id) {
                listResp.status = status === 1 ? 0 : 1;
              }
              return listResp;
            });
            this.setState({ list });
            swal('', `Successfully ${statusTxt}d location!`, 'success');
          } else {
            swal('', 'Something went wrong!', 'error');
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    });
  }

  addToggle() {
    this.toggleModal('Add');
    this.setState({
      formdata: { locationName: '', address: '', type: '' },
      errorMsg: '',
    });
    this.handleSubmit = (e) => { this.addSubmitForm(e); };
  }

  addSubmitForm(e) {
    e.preventDefault();
    const { formdata } = this.state;

    if (formdata.locationName && formdata.type) {
      // add location
      Location.addLocation(formdata).then((result) => {
        const responseJson = result;
        if (responseJson === true) {
          this.onLoadLocations();
          this.setState({ errorMsg: '', modal: false });

          swal({
            title: 'New Location was added!',
            text: 'Would you like to add a new location?',
            icon: 'success',
            closeOnClickOutside: false,
            buttons: {
              no: 'NOPE',
              yes: 'ADD NEW',
            },
          }).then((name) => {
            name = name.toLowerCase();

            if (name === 'yes') {
              this.addToggle();
            }
          });
        } else {
          this.setState({ errorMsg: result });
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ errorMsg: 'Required fields are empty.' });
    }
  }

  handleClick(event = '') {
    const selected = event !== '' ? event.selected + 1 : 1;
    const { realList } = this.state;

    const lastPost = selected * 10;
    const firstPost = lastPost - 10;

    const newList = realList.slice(firstPost, lastPost);
    this.setState({ list: newList });
 }

  editToggle(id) {
    this.toggleModal('Edit');
    this.setState({ errorMsg: '' });

    // get location info
    Location.getLocationInfo(id).then((result) => {
      if (result) {
        this.setState({
          formdata: {
            locationName: result.location_name,
            address: result.location_address,
            type: result.type,
          },
        });
      }
    }).catch((error) => {
      console.log(error);
    });

    // submit form
    this.handleSubmit = (e) => { this.editSubmitForm(e, id); };
  }

  editSubmitForm(e, id) {
    e.preventDefault();
    const { formdata } = this.state;
    formdata.id = id;
    if (formdata.locationName && formdata.type) {
      Location.editLocation(formdata)
      .then((result) => {
        if (result === true) {
          const { list } = this.state;
          list.filter((listResp) => {
            if (listResp.location_id === id) {
              listResp.location_name = formdata.locationName;
              listResp.location_address = formdata.address;
              listResp.type = formdata.type;
            }
            return listResp;
          });
          this.setState({ list, modal: false });

          swal('', 'Successfully updated product name!', 'success');
        } else {
          this.setState({ errorMsg: result });
        }
      }).catch((error) => {
        console.log(error);
      });
    } else {
      this.setState({ errorMsg: 'Required fields are empty.' });
    }
  }

  toggleModal(text = '') {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (text) {
      this.setState({ title: text });
    }
  }

  render() {
    const {
      list, modal, formdata, title, errorMsg, realList,
    } = this.state;
    const { locationType, statusType } = global;

    return (
      <Col md={12}>
        <LocationModal
          title={`${title} Location`}
          modal={modal}
          toggle={this.toggleModal}
          handleChange={this.handleChange}
          postValue={formdata}
          handleSubmit={this.handleSubmit}
          errorMsg={errorMsg}
        />
        <Card className="panel panel--primary do_magic" id="users_table">
          <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">LOCATIONS</h5>

              <div className="panel__btns">
                <Button onClick={this.addToggle} className="rounded text-white" size="sm" outline><i className="fa fa-map-marker-alt m-r-4" /> <span>Add Location</span></Button>
              </div>
            </div>
            <div className="panel__content">
              <Table responsive striped className="doResTable">
                <thead>
                  <tr>
                    <th>Location Name</th>
                    <th>Location Address</th>
                    <th>Type</th>
                    <th width="20%" className="text-center">Status</th>
                    <th width="10%" className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    list !== false || list.length > 0 ? list.map((item, i) => {
                      item.status = parseInt(item.status, 10);
                      let statusColor = 'success';
                      let btnColor = 'danger';
                      let btnIcon = 'times';
                      let tooltipText = 'Delete';
                      let statusText = 'Deactivate';
                      if (item.status === 1) {
                        statusColor = 'danger';
                        btnColor = 'success';
                        btnIcon = 'check';
                        tooltipText = 'Activate';
                        statusText = 'Activate';
                      }

                      return (
                        <tr key={item.location_id}>
                          <td>{item.location_name}</td>
                          <td className="white-space-pre-wrap">{item.location_address ? item.location_address : '-'}</td>
                          <td>{locationType[item.type] ? locationType[item.type] : '-'}</td>
                          <td className="text-center"><Badge color={statusColor}>{statusType[item.status]}</Badge></td>
                          <td className="text-center ab">
                            {
                              /* Edit */
                              item.status === 0 && (
                                <>
                                  <Button color="primary" className="btn-xs" onClick={() => this.editToggle(item.location_id)} id={`locteditbtn${i + 1}`} outline><span className="lnr lnr-pencil" /></Button>
                                  <UncontrolledTooltip placement="bottom" target={`locteditbtn${i + 1}`}>Edit</UncontrolledTooltip>
                                </>
                              )
                            }
                            {/* Activate / Deactivate */}
                            <Button color={btnColor} className="btn-xs" title={tooltipText} onClick={e => this.updateLocationStatus(e, item.location_id, item.status)} id={`statusbtn${i + 1}`} outline><span className={`fa fa-${btnIcon}`} /></Button>
                            <UncontrolledTooltip placement="bottom" target={`statusbtn${i + 1}`}>{statusText}</UncontrolledTooltip>
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr className="text-center">
                        <td colSpan="6">No data available..</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
              <FormGroup className={list === false || (realList.length / 10) <= 1 ? 'display-none' : ''}>
                <ReactPaginate
                    previousLabel="<<"
                    nextLabel=">>"
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={realList.length / 10}
                    onPageChange={this.handleClick}
                    marginPagesDisplayed={0}
                    pageRangeDisplayed={2}
                    containerClassName="list-pagination"
                    activeClassName="active"
                />
              </FormGroup>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(LocationLists);
